"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataFromVariablesSharingSameShapeDuplicateRows = exports.getDataFromVariablesSharingSameShapeDuplicateColumns = exports.filterAllowedAttributes = exports.identifyKeyDimensions = exports.getVariablesSharingSameShape = void 0;
const NcoVariableTree_1 = require("../NcoVariableTree");
exports.getVariablesSharingSameShape = (ncoJson) => {
    return Object.keys(ncoJson.variables)
        .filter((variableKey) => !ncoJson.dimensions[variableKey])
        .reduce((prevDimensionSets, variableKey) => {
        const dimensionSetId = ncoJson.variables[variableKey].shape.join('_');
        return {
            ...prevDimensionSets,
            [dimensionSetId]: [...(prevDimensionSets[dimensionSetId] ? prevDimensionSets[dimensionSetId] : []), variableKey],
        };
    }, {});
};
exports.identifyKeyDimensions = (ncoJson) => {
    const latDimensionKey = Object.keys(ncoJson.dimensions).find((variableKey) => variableKey.includes('lat'));
    const lonDimensionKey = Object.keys(ncoJson.dimensions).find((variableKey) => variableKey.includes('lon'));
    const depthDimensionKey = Object.keys(ncoJson.dimensions).find((variableKey) => { var _a, _b; return variableKey.includes('depth') || ((_b = (_a = ncoJson.variables[variableKey]) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.standard_name) === 'depth'; });
    const levelDimensionKey = Object.keys(ncoJson.dimensions).find((variableKey) => variableKey.includes('level'));
    const dateDimensionKey = 'time';
    const dateVariable = ncoJson.variables[dateDimensionKey];
    if (!latDimensionKey || !lonDimensionKey || !dateVariable) {
        throw new Error('Could not find lon, lat, time dimensions');
    }
    return {
        latDimensionKey,
        lonDimensionKey,
        dateDimensionKey,
        depthDimensionKey,
        levelDimensionKey,
    };
};
exports.filterAllowedAttributes = (attributes = {}) => {
    const allowedAttributes = [
        'long_name',
        'short_name',
        'standard_name',
        'units',
        'valid_min',
        'valid_max',
        'axis',
        'cell_methods',
        'positive',
        'NAVO_code',
        'cell_methods',
        'direction_sense',
        'direction_reference',
        'parameter_label',
        'definition',
        'parameter_name',
        'DLP_group_parameter',
    ];
    return Object.keys(attributes).reduce((prev, key) => {
        if (allowedAttributes.includes(key)) {
            return {
                ...prev,
                [key]: attributes[key],
            };
        }
        else {
            return prev;
        }
    }, {});
};
exports.getDataFromVariablesSharingSameShapeDuplicateColumns = ({ ncoJson, variables, ncoVariableTreeConfig, rowDimensionName, order, }) => {
    const rowDimensionIndicies = new Array(ncoJson.dimensions[rowDimensionName]).fill(0).map((_, i) => i);
    const columns = [
        {
            label: rowDimensionName,
            meta: ncoJson.variables[rowDimensionName].attributes || {},
        },
    ];
    const rowsAsc = rowDimensionIndicies.map((currentRowDimensionIndex) => {
        const firstColumn = ncoJson.variables[rowDimensionName].data[currentRowDimensionIndex];
        const newNcoVariableTreeConfig = {
            ...ncoVariableTreeConfig,
            excludeDimensions: [
                ...((ncoVariableTreeConfig === null || ncoVariableTreeConfig === void 0 ? void 0 : ncoVariableTreeConfig.excludeDimensions) || []),
                { dimensionKey: rowDimensionName, inclusiveIndexRange: [currentRowDimensionIndex, currentRowDimensionIndex] },
            ],
        };
        const variableColumns = variables
            .map((variableKey) => {
            const tree = new NcoVariableTree_1.NcoVariableTree(ncoJson, variableKey, newNcoVariableTreeConfig);
            const row = tree.flattenData().map((nodePointer) => {
                if (currentRowDimensionIndex === 0) {
                    const atDimension = tree.targetVariable.shape
                        .filter((dimensionName) => rowDimensionName !== dimensionName)
                        .reduce((prev, dimensionName) => {
                        return {
                            ...prev,
                            [dimensionName]: tree.getDimensionValue(dimensionName, nodePointer),
                        };
                    }, {});
                    const column = {
                        label: variableKey,
                        meta: exports.filterAllowedAttributes(tree.targetVariable.attributes || {}),
                        atDimension,
                    };
                    columns.push(column);
                }
                return tree.getData(nodePointer);
            });
            return row;
        })
            .flat();
        return [firstColumn, ...variableColumns];
    });
    return {
        rows: order === 'ASC' ? rowsAsc : rowsAsc.reverse(),
        columns,
    };
};
exports.getDataFromVariablesSharingSameShapeDuplicateRows = ({ variables, ncoJson, ncoVariableTreeConfig, order, }) => {
    var _a;
    const headers = [];
    const excludeDimensions = ((_a = ncoVariableTreeConfig === null || ncoVariableTreeConfig === void 0 ? void 0 : ncoVariableTreeConfig.excludeDimensions) === null || _a === void 0 ? void 0 : _a.map((filterDimensionConfig) => filterDimensionConfig.dimensionKey)) || [];
    const otherDimensions = ncoJson.variables[variables[0]].shape.filter((dimensionInShape) => !excludeDimensions.includes(dimensionInShape));
    headers.push(...otherDimensions.map((otherDimension) => {
        var _a;
        return ({
            label: otherDimension,
            meta: exports.filterAllowedAttributes((_a = ncoJson.variables[otherDimension]) === null || _a === void 0 ? void 0 : _a.attributes),
        });
    }));
    const variableTrees = variables.map((variableKey) => {
        const tree = new NcoVariableTree_1.NcoVariableTree(ncoJson, variableKey, ncoVariableTreeConfig);
        headers.push({
            label: tree.targetVariableKey,
            meta: exports.filterAllowedAttributes(tree.targetVariable.attributes),
        });
        return tree;
    });
    const rowsDesc = variableTrees[0].flattenData().map((nodePointer) => {
        return [
            ...otherDimensions.map((dimensionKey) => variableTrees[0].getDimensionValue(dimensionKey, nodePointer)),
            ...variableTrees.map((variableTree) => {
                return variableTree.getData(nodePointer);
            }),
        ];
    });
    return {
        headers,
        rows: order === 'ASC' ? rowsDesc.reverse() : rowsDesc,
    };
};
